module.exports = __webpack_public_path__ + "static/img/2.5ca3c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/2.jpg
// module id = OH2a
// module chunks = 1